// extracted by mini-css-extract-plugin
export var attachmentContainer = "_mf-0";
export var fileList = "_mf-2";
export var removeFileButton = "_mf-1";